import { Component, computed, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { SelfCheckoutStreamStore } from '@formunauts/self-checkout/data-access';
import { SelfCheckout } from '@formunauts/self-checkout/domain';
import { SHARED_UI_COMMON_EMPTY_STATES } from '@formunauts/shared/ui';
import * as O from 'effect/Option';
import { first } from 'rxjs';
import { getEmptyStateForGetForm } from '../self-checkout-feature-utils';
/**
 * Wrapper page for the self checkout form.
 */
@Component({
  selector: 'verify-verify-page',
  templateUrl: './self-checkout-page.component.html',
  standalone: true,
  imports: [RouterModule, SharedModule],
})
export class SelfCheckoutPageComponent {
  private readonly selfCheckoutSignalStore = inject(SelfCheckoutStreamStore);
  protected readonly sharedUi = inject(SHARED_UI_COMMON_EMPTY_STATES);

  protected readonly vm = computed(() => ({
    authForm: O.getOrNull(this.selfCheckoutSignalStore.authForm()),
    errors: O.getOrNull(this.selfCheckoutSignalStore.authFormError()),
  }));

  constructor() {
    const router = inject(Router);

    this.selfCheckoutSignalStore.getAuthForm(this.selfCheckoutSignalStore.hash);

    toObservable(this.selfCheckoutSignalStore.status)
      .pipe(
        first((status) => status !== SelfCheckout.FlowStatus.Init),
        takeUntilDestroyed(),
      )
      .subscribe((status) => {
        const hash = this.selfCheckoutSignalStore.hash();
        if (status === SelfCheckout.FlowStatus.Done) {
          return router.navigate(['verify', hash, 'completed']);
        }
      });
  }
  errorToString(error: SelfCheckout.SelfCheckoutError): {
    text: string;
    translate?: boolean;
  } {
    return getEmptyStateForGetForm(error);
  }
}
